import { pxToChars } from "../../../utils/excelToFortuneSheet";
import { DEFAULT_WEEK_COLUMN_WIDTH, WEEK_COLUMN_COUNT } from "../constants";

/**
 * Widths for the seven weekday columns.
 *
 * Overrides arrive from the spreadsheet preview in pixels, keyed by column index, and only exist for
 * columns the user has actually dragged.
 */
export const computeWeekColumnWidths = (columnWidthOverrides: Record<string, number> | undefined): { width: number }[] =>
	Array.from({ length: WEEK_COLUMN_COUNT }, (_, index) => {
		const overridePx = columnWidthOverrides?.[String(index)];
		// DEFAULT: an undragged column has no measured width; fall back to the preview's own default so
		// the download matches what the user was just looking at.
		return { width: overridePx === undefined ? DEFAULT_WEEK_COLUMN_WIDTH : pxToChars(overridePx) };
	});
